<template>
    <div class="landing-page-loader background-secondary"
         v-if="loading">
        <stamp class="animate animate--long animate--rotate primary-text"></stamp>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Stamp from '../../components/stamp/Stamp';

    export default Vue.extend({
        components: {
            Stamp,
        },
        data() {
            return {
                loading: true
            }
        }
    });
</script>
